<template>
  <BaseModal
    :id="'delete-validations'"
    :title="`Validations`"
    :size="'lg'"
    :message="message"
    @close="close($event)"
  >
    <template v-slot:breadcrumb>
      <Breadcrumb :breadcrumb="breadcrumb_local" />
    </template>

   
    <template v-slot:content>
      <form>
        <div
          class="w-100 table-responsive defaultproject__table overflow-y--2 table-fix-head"
        >
          <table class="table">
            <thead>
              <tr style="background-color: #fff">
                <th
                  style="font-weight: normal !important"
                  class="header-item-manual"
                  v-for="(item, i) in summary_table_headers"
                  :key="i"
                  scope="col"
                  v-html="item.name"
                />
              </tr>
            </thead>
            <tbody>
              <template>
                <tr v-for="(item, i) in validate_data" :key="i">
                  <td v-html="`${i + 1}`" />
                  <td
                    v-html="item.description"
                  />
                  <td
                    v-html="item.message"
                  />
                </tr>
              </template>
            </tbody>
          </table>
        </div>
        <CentralLiteButtons :save_text="'Done'" />
      </form>
    </template>
  </BaseModal>
</template>

<script>
import Breadcrumb from "@/components/BreadcrumbComponent/Breadcrumb";
import CentralLiteButtons from "@/components/CentralLiteButtons";
import BaseModal from "@/components/BaseModal";

export default {
  name: "DeleteValidationsModal",

  props: ["breadcrumb", "validate_data"],

  components: {
    BaseModal,
    Breadcrumb,
    CentralLiteButtons,
  },

  data() {
    return {
      summary_table_headers: [
        {
          name: "#",
        },
        {
          name: "Room Type",
        },
        {
          name: "Associated Rooms",
        },
      ],
      
      validations_associate: null,
      breadcrumb_local: [...this.breadcrumb],
      message: `The following room types were not deleted because other records are associated with them`,
      select_all: true,
    };
  },

  methods: 
  {
    close(event) {
      this.$emit("close", event);
    },

  },

  computed: {},

  mounted() {
    this.breadcrumb_local[this.breadcrumb.length - 1].arrow =
      "<span class='slash'>/</span>";
    this.breadcrumb_local.push({
      name: "Validation Modal",
      arrow: "",
    });
  },
};
</script>
